/**
 * Cookie lišta – orestbida/cookieconsent v3.
 *
 * Knihovna je globál z vendor bundle (js/vendor/cookieconsent/cookieconsent.umd.js).
 * Konfigurace je záměrně na jednom místě pro celý web – stačí ji přidat do
 * šablony a lišta se chová všude stejně.
 *
 * KATEGORIE odpovídají tomu, co se v EU (GDPR + ePrivacy) běžně odděluje.
 * Připravené jsou i do zásoby – ať je co zaškrtnout, až se dané nástroje
 * nasadí. Kategorie bez jediné aktivní služby se dá klidně smazat.
 *
 *   necessary       – nutné pro provoz včetně reCAPTCHy, nejdou vypnout
 *   functional      – zapamatované volby na webu
 *   analytics       – měření návštěvnosti
 *   marketing       – reklama a remarketing
 *   personalization – doporučování obsahu podle chování
 *   social          – vložený obsah ze sociálních sítí a map
 *
 * JAK PŘIDAT SKRIPT do kategorie (spustí se až po souhlasu):
 *   <script type="text/plain" data-category="analytics" data-service="Google Analytics 4">
 *       …kód měřáku…
 *   </script>
 *
 * Přístupnost: knihovna sama řeší roli dialogu, fokus i popisky. Tlačítko
 * „Nastavení cookies" v patičce otevírá okno přes atribut data-cc, takže
 * nepotřebuje vlastní JS.
 */
function initCookieConsent() {
    if (typeof CookieConsent === 'undefined') return;

    CookieConsent.run({
        // souhlas platí rok, pak se lišta zeptá znovu
        cookie: {
            name: 'lv_kominik_consent',
            expiresAfterDays: 365,
        },

        guiOptions: {
            consentModal: {
                layout: 'cloud',
                position: 'bottom center',
                equalWeightButtons: false, // „Jen nutné" nesmí být schované, ale ani stejně výrazné
                flipButtons: false,
            },
            preferencesModal: {
                layout: 'box',
                equalWeightButtons: true,
            },
        },

        categories: {
            // reCAPTCHA je tu schválně: bez ní by šel formulář zneužít roboty,
            // takže ji řadíme mezi nutné (ochrana služby, kterou návštěvník sám
            // vyvolal). Když ji budete chtít až po souhlasu, přesuňte ji do
            // functional a formulář nechte odeslat i bez ní.
            necessary: {
                enabled: true,
                readOnly: true,
                services: {
                    session: { label: 'Přihlašovací a session cookie (PHPSESSID)' },
                    recaptcha: { label: 'Google reCAPTCHA (ochrana formulářů proti spamu)' },
                },
            },

            functional: {
                services: {
                    preferences: { label: 'Zapamatované volby na webu' },
                },
            },

            analytics: {
                autoClear: {
                    cookies: [
                        { name: /^_ga/ },
                        { name: '_gid' },
                        { name: /^_gat/ },
                    ],
                },
                services: {
                    gtm: { label: 'Google Tag Manager' },
                    ga4: { label: 'Google Analytics 4' },
                },
            },

            marketing: {
                autoClear: {
                    cookies: [
                        { name: /^_gcl/ },
                    ],
                },
                services: {
                    google_ads: { label: 'Google Ads (remarketing a měření konverzí)' },
                },
            },

            personalization: {
                services: {
                    ab_testing: { label: 'A/B testování a doporučování obsahu' },
                },
            },

            social: {
                autoClear: {
                    cookies: [
                        { name: /^VISITOR_INFO1_LIVE|^YSC/ },
                    ],
                },
                services: {
                    youtube: { label: 'YouTube videa' },
                    maps: { label: 'Mapy a vložený obsah' },
                },
            },
        },

        language: {
            default: 'cs',
            translations: {
                cs: {
                    consentModal: {
                        title: 'Na webu používáme cookies',
                        description:
                            'Nutné cookies potřebujeme k tomu, aby web fungoval. Ostatní zapneme jen s vaším souhlasem – pomáhají nám zjistit, co na webu hledáte, a ukázat vám relevantní nabídku. Podrobnosti najdete v <a href="/prohlaseni-o-cookies">prohlášení o cookies</a>.',
                        acceptAllBtn: 'Přijmout vše',
                        acceptNecessaryBtn: 'Jen nutné',
                        showPreferencesBtn: 'Nastavení',
                    },
                    preferencesModal: {
                        title: 'Nastavení cookies',
                        acceptAllBtn: 'Přijmout vše',
                        acceptNecessaryBtn: 'Jen nutné',
                        savePreferencesBtn: 'Uložit nastavení',
                        closeIconLabel: 'Zavřít',
                        serviceCounterLabel: 'služba|služby',
                        sections: [
                            {
                                title: 'Jak cookies používáme',
                                description:
                                    'Cookies jsou malé soubory, které si web ukládá do prohlížeče. Níže si můžete zapnout jen ty kategorie, se kterými souhlasíte – a u některých i jednotlivé nástroje. Volbu jde kdykoli změnit odkazem „Nastavení cookies" v patičce.',
                            },
                            {
                                title: 'Nutné cookies <span class="pm__badge">Vždy zapnuté</span>',
                                description:
                                    'Bez nich web nefunguje – drží session (PHPSESSID), pamatují si vaši volbu cookies a chrání formuláře proti spamu (Google reCAPTCHA). Nejdou vypnout.',
                                linkedCategory: 'necessary',
                            },
                            {
                                title: 'Funkční cookies',
                                description:
                                    'Pamatují si vaše volby (například zavřené hlášky) a umožňují chat nebo vložené formuláře. Bez nich web funguje, jen méně pohodlně.',
                                linkedCategory: 'functional',
                            },
                            {
                                title: 'Analytické cookies',
                                description:
                                    'Přes Google Tag Manager spouštíme Google Analytics 4. Měří, které stránky si lidé prohlížejí a odkud přišli – vyhodnocujeme je v souhrnu, ne po jednotlivcích.',
                                linkedCategory: 'analytics',
                            },
                            {
                                title: 'Marketingové cookies',
                                description:
                                    'Umožňují ukázat naši nabídku lidem, kteří web už navštívili, a měřit, jestli má reklama smysl. Bez souhlasu se nespustí.',
                                linkedCategory: 'marketing',
                            },
                            {
                                title: 'Personalizace obsahu',
                                description:
                                    'Přizpůsobuje, co na webu uvidíte – například jaké služby nebo realizace vám nabídneme jako první.',
                                linkedCategory: 'personalization',
                            },
                            {
                                title: 'Sociální sítě a vložený obsah',
                                description:
                                    'Potřebné pro videa, mapy a příspěvky ze sociálních sítí vložené přímo do stránky. Tyto služby si mohou ukládat vlastní cookies.',
                                linkedCategory: 'social',
                            },
                            {
                                title: 'Další informace',
                                description:
                                    'Co přesně ukládáme a jak dlouho, najdete v <a href="/prohlaseni-o-cookies">prohlášení o cookies</a> a v <a href="/ochrana-osobnich-udaju">zásadách ochrany osobních údajů</a>. Souhlas můžete kdykoli odvolat.',
                            },
                        ],
                    },
                },
            },
        },
    });
}

document.addEventListener('DOMContentLoaded', initCookieConsent);
